import { render, staticRenderFns } from "./subject-card.vue?vue&type=template&id=6d6a7d96&scoped=true"
import script from "./subject-card.vue?vue&type=script&lang=js"
export * from "./subject-card.vue?vue&type=script&lang=js"
import style0 from "./subject-card.vue?vue&type=style&index=0&id=6d6a7d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a7d96",
  null
  
)

export default component.exports